import { SubBrand } from '@occc/feat-constraints';

type GetActiveSubBrandNameArgs = {
  activeSubBrandUuid: string;
  subBrandList: SubBrand[];
};

export const getActiveSubBrandName = ({
  activeSubBrandUuid,
  subBrandList,
}: GetActiveSubBrandNameArgs) => {
  return subBrandList.find((subBrand) => subBrand.uuid === activeSubBrandUuid)?.name;
};
